<template>
  <v-container v-if="template"
               fluid>
    <PageTitle>
      Copy Email Template to another Team
    </PageTitle>

    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card>
        <v-card-text>

          <p>
            You can copy <strong>{{ template.name }}</strong> to another Mobile Locker team.
          </p>

          <v-select label="Select the team"
                    v-model="form.team_id"
                    :items="otherTeams"
                    item-value="id"
                    item-text="name"
                    hint="Which team do you want to copy this template to?"
                    persistent-hint
                    outlined
                    dense
                    :error-messages="form.errors.get('team_id')">
          </v-select>

          <v-switch v-model="form.switch_to_team"
                    label="Switch to that team and edit the template there"
                    hide-details>
          </v-switch>
        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn color="primary"
                 type="submit"
                 :disabled="form.busy || !this.form.team_id">
            Copy to team
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import {find} from 'lodash';
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import shareTemplateService from '../../../../ml/services/shareTemplateService';
import userService from "../../services/userService";
import DOMPurify from 'dompurify';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle},
  data() {
    return {
      form: new Form({
        switch_to_team: true,
        team_id: '',
      }),
      template: null,
    }
  },
  computed: {
    ...mapGetters([
      'activeTeams', // MLD-3800
      'otherTeams', // MLD-3800
      'teams',
      'team',
      'user',
      'users',
    ]),
    otherTeam() {
      if (this.form.team_id) {
        return find(this.activeTeams, t => t.id === this.form.team_id);
      }
      return null;
    },
    templateID() {
      return parseInt(this.$route.params.templateID);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.form.busy = true;
      shareTemplateService.getTemplate(this.templateID)
        .then(data => {
          this.template = data;
        })
        .catch(err => {
          // Template not found, show an error
        })
        .finally(() => {
          this.form.busy = false;
        })
    },
    async submit() {
      if (this.form.busy) {
        return;
      }
      try {
        const result = await shareTemplateService.copyToTeam(this.form, this.templateID)
        if (this.form.switch_to_team) {
          await userService.switchUserToTeam(this.user.id, this.form.team_id)
          if (this.otherTeam) {
            this.$toast.success(`Copied ${DOMPurify.sanitize(this.template.name)} and switched to team ${DOMPurify.sanitize(this.otherTeam.name)}.`)
            window.location.replace(`/v2/admin/email-templates/${result.template_id}/edit`);
          }
        } else {
          if (this.otherTeam) {
            this.$toast.success(`Copied ${DOMPurify.sanitize(this.template.name)} to team ${DOMPurify.sanitize(this.otherTeam.name)}.`)
          }
          this.$store.dispatch('fetchShareTemplates').then(); // MLD-6865
          this.$router.push({name: 'admin.share_templates.index'});
        }
      } catch (e) {
      }
    }
  }
}
</script>
